<template>
  <div class="row">
    <div
      v-for="entry in entries"
      :key="entry.id"
      class="col-lg-4"
    >
      <post-grid :content="entry" />
    </div>
  </div>
</template>

<script>
import PostGrid from '@/components/posts/PostGrid'

export default {
  name: 'ContentGridView',
  components: {
    PostGrid
  },
  props: {
    entries: {
      type: Array,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contents/ContentLayoutGridView.vue